const meta = {
  description:
    "Centralno skladišče Zalog, novo sodobno centralno skladišče v središču Slovenije. Na stičišču regionalnih in mednarodnih oskrbovalnih poti.",
  title: "BTC Logistični center Zalog",
};

export default meta;
